import React from 'react';
import { Icon } from './Icon';

/** Generic sortable table. Ported from D:\campaigning-system\src\components\tables\DataTable.tsx. */
export function DataTable({ columns, rows, rowKey, onRowClick, sort, onSort, rowActions, emptyLabel = 'No results match your filters.' }) {
  const alignClass = (a) => (a === 'right' ? 'text-right' : a === 'center' ? 'text-center' : 'text-left');

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="border-b border-cos-line">
            {columns.map((col) => {
              const active = sort?.key === col.key;
              return (
                <th
                  key={col.key}
                  style={{ width: col.width }}
                  className={`whitespace-nowrap px-3 py-2.5 text-2xs font-bold uppercase tracking-[0.08em] text-cos-ink-muted ${alignClass(col.align)}`}
                >
                  {col.sortable && onSort ? (
                    <button
                      onClick={() => onSort(col.key)}
                      className={`inline-flex items-center gap-1 transition-colors hover:text-cos-teal-deep ${active ? 'text-cos-teal-deep' : ''} ${col.align === 'right' ? 'flex-row-reverse' : ''}`}
                    >
                      {col.header}
                      <Icon
                        name={active ? (sort?.dir === 'asc' ? 'arrow_upward' : 'arrow_downward') : 'unfold_more'}
                        className="text-[15px]"
                      />
                    </button>
                  ) : (
                    col.header
                  )}
                </th>
              );
            })}
            {rowActions && <th className="w-1 px-3 py-2.5" />}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length + (rowActions ? 1 : 0)} className="px-3 py-12 text-center">
                <div className="flex flex-col items-center gap-2 text-cos-ink-muted">
                  <Icon name="search_off" className="text-[28px]" />
                  <span className="text-sm">{emptyLabel}</span>
                </div>
              </td>
            </tr>
          ) : (
            rows.map((row) => (
              <tr
                key={rowKey(row)}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={`group border-b border-cos-line-subtle transition-colors last:border-0 hover:bg-[rgba(13,168,155,0.05)] ${onRowClick ? 'cursor-pointer' : ''}`}
              >
                {columns.map((col) => (
                  <td key={col.key} className={`px-3 py-3 align-middle ${alignClass(col.align)} ${col.className ?? ''}`}>
                    {col.render(row)}
                  </td>
                ))}
                {rowActions && (
                  <td className="px-3 py-3 text-right">
                    <div className="flex items-center justify-end gap-1 opacity-0 transition-opacity group-hover:opacity-100 focus-within:opacity-100">
                      {rowActions(row)}
                    </div>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default DataTable;
